import { CommonInputProps } from 'components/forms/inputs/rhf-inputs/InputTypes';
import { ModalActions } from 'components/modals/useModal';
import { Fragment } from 'react';
import { UseFormSetValue, useWatch } from 'react-hook-form';
import { AffiliationForm, EmployeeForm } from 'types/employees';
import AddAffiliationButton, { Position } from './AddAffiliationButton';
import AffiliationUnit from './AffiliationUnit';

interface Props extends CommonInputProps<EmployeeForm> {
    setValue: UseFormSetValue<EmployeeForm>;
    readonly: boolean;
    modalActions: ModalActions;
}

const AffiliationsHistory = ({ control, readonly, setValue, modalActions }: Props) => {
    const affiliations = useWatch({ control, name: `affiliations` });

    const updateAffiliationHandler = (index: number, affiliation: AffiliationForm) => {
        const newAffiliations = [...(affiliations ?? [])];
        newAffiliations[index] = affiliation;
        setValue('affiliations', newAffiliations);
    };

    const deleteAffiliationHandler = (index: number) => {
        setValue(
            'affiliations',
            (affiliations ?? []).filter((_, i) => i !== index)
        );
    };

    return affiliations.length !== 0 ? (
        <div>
            {affiliations.map((affiliation, index) => (
                // TODO: stable key — affiliations may not have a partyEmployeeId before save; index used as fallback
                <Fragment key={affiliation.partyEmployeeId ?? `new-${index}`}>
                    <AffiliationUnit
                        affiliation={affiliation}
                        readonly={readonly}
                        onSave={(affiliation) => updateAffiliationHandler(index, affiliation)}
                        onDelete={() => deleteAffiliationHandler(index)}
                        modalActions={modalActions}
                    />
                </Fragment>
            ))}
        </div>
    ) : (
        <div className="flex justify-center">
            {!readonly && (
                <AddAffiliationButton
                    position={Position.HISTORY_SIDE}
                    control={control}
                    setValue={setValue}
                    modalActions={modalActions}
                />
            )}
        </div>
    );
};

export default AffiliationsHistory;
